import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import InputSearch from "components/Input/InputSearch";
import OrderByButton from "./components/OrderByButton";
import FiltrosHeaderTable from "./components/FiltrosHeaderTable/index";
import { Checkbox } from "antd";

interface ListingPageHeaderBarProps {
  onSearch: (q?: string) => void;
  onFiltro?: () => void;
  onOrderDirectionChange?: (q?: string) => void;
  orderDirection?: any;
  onOrderByChange?: (q?: any) => void;
  orderBy?: string | undefined;
  valueSearch?: string;
  orderByOptions?: {
    value: string;
    label: string;
  }[];
  children?: any;
  visibleFiltro?: boolean;
  badge?: boolean;
  badgeValue?: number;
  showOrderByButton?: boolean;

  indeterminate?: boolean;
  onCheckAllChange?: (e: any) => void;
  checkAll?: boolean;
  checkbox?: boolean;
  wrapChildren?: boolean;
  searchMaxWidth?: string;
  extraModalButton?: React.ReactNode;
}

export default function ListingPageHeaderBar({
  children,
  onFiltro,
  onSearch,
  valueSearch,
  badge,
  badgeValue,
  visibleFiltro,
  showOrderByButton,
  orderByOptions = [],
  onOrderDirectionChange = () => {},
  onOrderByChange = () => {},
  orderBy,
  orderDirection,
  checkAll,
  indeterminate,
  onCheckAllChange,
  checkbox = false,
  wrapChildren,
  searchMaxWidth = "420px",
  extraModalButton = null,
}: ListingPageHeaderBarProps) {
  return (
    <Flex
      flexDir="column"
      bg={colors.white}
      py={6}
      px={3}
      rounded={20}
      gridGap={4}
    >
      <Flex>
        {checkbox ? (
          <Flex align="center" mr={2} left="0px">
            <Checkbox
              indeterminate={indeterminate}
              onChange={onCheckAllChange}
              checked={checkAll}
            />
          </Flex>
        ) : null}

        <Flex flex={1} gap={4} alignItems="center">
          <InputSearch
            defaultValue={valueSearch || ""}
            onSearch={(v) => onSearch(v)}
            maxW={searchMaxWidth}
          />

          <Flex flex={2} gap={3}>
            {visibleFiltro ? (
              <Flex>
                <FiltrosHeaderTable
                  badge={badge}
                  badgeValue={badgeValue}
                  onFiltro={onFiltro!}
                />
              </Flex>
            ) : null}

            {extraModalButton}

            {children && !wrapChildren ? (
              <Flex flex={1}>{children}</Flex>
            ) : null}
          </Flex>

          {showOrderByButton ? (
            <OrderByButton
              onOrderDirectionChange={onOrderDirectionChange}
              orderDirection={orderDirection}
              orderBy={orderBy}
              onOrderByChange={onOrderByChange}
              options={orderByOptions}
            />
          ) : null}
        </Flex>
      </Flex>

      {children && wrapChildren ? <Flex flex={1}>{children}</Flex> : null}
    </Flex>
  );
}
